module.exports = __webpack_public_path__ + "img/3.6958e26e.png";